import { NgModule } from '@angular/core';
import { CardComponentModule, SharedModule } from 'lib-trend-core';
import { ContactGroupModule } from '../contact-group/contact-group.module';
import { ContactRoutingModule } from '../contact/contact-routing.module';
import { AttendanceHistoryModule } from './attendance-history/attendance-history.module';
import { ConfirmationCloseAttendanceModule } from './attendance-panel/attendance-panel-components/confirmation-close-attendance/confirmation-close-attendance.module';
import { AttendancePanelModule } from './attendance-panel/attendance-panel.module';
import { AttendanceRoutingModule } from './attendance-routing.module';
import { AttendanceComponent } from './attendance.component';
import { AttendanceMonitoringComponent } from './attendance-monitoring/attendance-monitoring.component';
import { AttendanceMonitoringColumnComponent } from './attendance-monitoring/attendance-monitoring-column/attendance-monitoring-column.component';
import { MonitoringSettingsDialogComponent } from './attendance-monitoring/monitoring-settings-dialog/monitoring-settings-dialog.component';

@NgModule({
  imports: [
    SharedModule,
    AttendanceRoutingModule,
    CardComponentModule,
    AttendancePanelModule,
    AttendanceHistoryModule,
    ContactGroupModule,
    ContactRoutingModule,
    ConfirmationCloseAttendanceModule
  ],
  declarations: [
    AttendanceComponent,
    AttendanceMonitoringComponent,
    AttendanceMonitoringColumnComponent,
    MonitoringSettingsDialogComponent,
  ],
  exports: [
    AttendanceComponent,
  ],
  providers: [],
  schemas: []
})
export class AttendanceModule { }
